import React, { FC } from "react";

import { Avatar } from "./Avatar";
import { MembersListProps } from "./Avatar.types";

export const MembersList: FC<MembersListProps> = ({
  items,
  title = "Members",
}) => {
  return (
    <div
      className={
        "flex max-h-[250px] w-[225px] flex-col overflow-hidden rounded-[10px] border border-gray-300 bg-white text-[13px] shadow-lg"
      }>
      <div
        className={
          "border-b border-gray-200 px-[11px] pb-[5px] pt-[7px] text-[11px] font-extrabold uppercase tracking-[0.5px] text-[#9097A8]"
        }>
        {title}
      </div>

      {items.length ? (
        <div className={"overflow-y-auto py-2"}>
          {items.map((member) => (
            <div
              key={member.id}
              className={"flex items-center gap-2 px-3 py-1.5 text-[#293B5A]"}>
              <div>
                <Avatar {...member} size={"md"} />
              </div>
              <div className={"min-w-0 truncate"}>
                {member.fullName || member.label || "Unnamed member"}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={"px-3 py-3 text-sm text-gray-500"}>No members</div>
      )}
    </div>
  );
};
